import utils from 'utils'

class detailCtrl {
    constructor($scope, httpRequest, globalFn, logger, $stateParams, $uibModal) {
        console.log($stateParams)
        $scope.invType = $stateParams.invType
        // 隐藏一二级菜单
        if ($stateParams.detailFlag === true) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        const types = ['preferential_code']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        let data = {
            invoiceId:$stateParams.invoiceId,
            needAdditional:false,
            needDetail:true,
            needExtend:false,
        }
        httpRequest.post_getPool(data).then((res) => {
            $scope.invoice = res.data.value.invoicePool
            $scope.detailItemList = res.data.value.detailList
            $scope.detailChineseTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
            formatSpecificData()
        })
        // 格式化 特定业务数据 展示
        function formatSpecificData() {
            if($scope.invoice.specificElements == '06'){ // 不动产租赁服务
                let realEstateSpecific = JSON.parse($scope.invoice.realEstateSpecific)
                $scope.detailItemList[0].certificateOfTitle = realEstateSpecific.certificateOfTitle
                $scope.detailItemList[0].unitOfArea = realEstateSpecific.unitOfArea
                realEstateSpecific.transRegionalFlag = realEstateSpecific.transRegionalFlag=='N'?'否':'是'
                let showRemark =  $scope.invoice.remark?$scope.invoice.remark:''
                $scope.showRemark = '不动产地址：'+ realEstateSpecific.administrativeRegion + realEstateSpecific.fullAddress
                    + '      租赁期起止：' + realEstateSpecific.leaseTermStart + ' ' + realEstateSpecific.leaseTermEnd
                    + '      跨地（市）标志：' + realEstateSpecific.transRegionalFlag
                    + '\n' + showRemark
            }
            if($scope.invoice.specificElements == '03') { // 建筑服务
                let realEstateSpecific = JSON.parse($scope.invoice.realEstateSpecific)
                let siteDetailedAddress =  realEstateSpecific.siteDetailedAddress?realEstateSpecific.siteDetailedAddress:''
                $scope.detailItemList[0].siteDetailedAddress = realEstateSpecific.site + siteDetailedAddress
                $scope.detailItemList[0].constructionProjectName = realEstateSpecific.constructionProjectName
                realEstateSpecific.transRegionalFlag = realEstateSpecific.transRegionalFlag=='N'?'否':'是'
                let showRemark =  $scope.invoice.remark?$scope.invoice.remark:''
                let showLandItemNumber =  realEstateSpecific.landItemNumber?realEstateSpecific.landItemNumber:'-'
                $scope.showRemark = '土地增值税项目编号：'+ showLandItemNumber
                    + '      跨地（市）标志：' + realEstateSpecific.transRegionalFlag
                    + '\n' + showRemark
            }
        }
    }
}

detailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$stateParams', '$uibModal']
export default detailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/invoicePool/outputInvoicePool/detailCtrl.js